import { apiClient } from '@app/lib'
import { type ApiResponse } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import ms from 'ms'
import { useSession } from 'next-auth/react'

export const usePhone = () => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    queryKey: ['phone'],
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<ApiResponse<{ phoneNumber: string | null | undefined }>>(`/api/phone`, {
        signal
      })

      return data.data?.phoneNumber
    },
    staleTime: ms('1h')
  })
}
